import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'url'
})

export class UrlPipe implements PipeTransform {
    transform(url: string): string {
        if (url && !url.startsWith("https://") && !url.startsWith("http://")) {
            url = "https://" + url;
        }
        return url;
    }
}

